import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook that scrolls to the top of the page when the route changes
 */
export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);
}

/**
 * Utility function to scroll to top of page or element
 */
export function scrollToTop(element?: HTMLElement | null, behavior: ScrollBehavior = 'smooth') {
  if (element) {
    element.scrollTo({
      top: 0,
      left: 0,
      behavior
    });
  } else {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior
    });
  }
}

/**
 * Custom hook for scrolling to top of a specific element
 */
export function useScrollToTopOnMount(elementRef?: React.RefObject<HTMLElement>) {
  useEffect(() => {
    if (elementRef?.current) {
      scrollToTop(elementRef.current);
    } else {
      scrollToTop();
    }
  }, [elementRef]);
}
